import { Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { IEnvironmentConfig } from '@core/app-config/env.config.model';

@Injectable({
  providedIn: 'root'
})
export class DatadogRumService {
  async init(envConfig: IEnvironmentConfig): Promise<void> {
    try {
      const datadogSettings = envConfig.datadogConfig;

      const proxyUrl =
        envConfig.env === 'local'
          ? 'https://ecom.roller.local/datadog-intake-proxy'
          : envConfig.env === 'prod'
            ? 'https://ecom.roller.app/datadog-intake-proxy'
            : `https://ecom.${envConfig.env}.roller.app/datadog-intake-proxy`;

      if (datadogSettings) {
        datadogRum.init({
          applicationId: '19c34682-572b-48d2-a06e-5b85a8133f23',
          clientToken: 'pub1312b0a91542ce8b21e56ce9f83ee044',
          site: 'datadoghq.com',
          service: 'checkout',
          env: envConfig.env,
          version: envConfig.env === 'local' ? `local-rum` : envConfig.version,
          sessionSampleRate: Number(datadogSettings.sessionSampleRate) || 100,
          sessionReplaySampleRate: datadogSettings.sessionReplayOnlyOnError
            ? 1
            : Number(datadogSettings.sessionReplaySampleRate) || 10,
          startSessionReplayRecordingManually: datadogSettings.sessionReplayOnlyOnError === 'true',
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          defaultPrivacyLevel: 'mask',
          allowedTracingUrls: [
            {
              match: envConfig.rollerApiBaseUrl,
              propagatorTypes: ['datadog', 'tracecontext']
            }
          ],
          beforeSend: (event) => {
            if (datadogSettings.sessionReplayOnlyOnError && event.type === 'error') {
              datadogRum.startSessionReplayRecording({ force: true });
            }

            return true;
          },
          proxy: proxyUrl
        });

        datadogRum.setGlobalContextProperty('cell', envConfig.appCell);

        console.log('Datadog RUM initialized successfully');
      } else {
        console.warn('Datadog RUM config incomplete. Skipping init.');
      }
    } catch (error) {
      console.error('Error initializing Datadog RUM:', error);
    }
  }
}
